export default {
    tooltip: 'Share micro-trend',
    copyToClipboard: 'Copy to clipboard',
    shareByMail: 'Share via email',
    copySuccess: 'Copying was successful',
    copyError: 'Copying did not work. Please copy manually.',
    subject: 'Recommended trend'
}
